import { StubPage } from '../StubPage'
export function Funnels() {
  return <StubPage title="Funnels & Connectors" summary="Connectors link Preparations together with conditional logic. A Funnel step evaluates one or more conditions against the current journey payload and routes the journey to a different Preparation based on the result. This enables if/else branching, approval workflows, and multi-path automations." />
}
